import { Navbar, Nav, Container } from "react-bootstrap";

export default function Menu() {
  return (
    <Navbar collapseOnSelect expand="lg" variant="dark">
      <Container>
        <Navbar.Brand href="#" className="font-primary color-primary fs-32">
          C T S
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="responsive-navbar-nav" />
        <Navbar.Collapse id="responsive-navbar-nav">
          <Nav className="ms-auto">
           <Nav.Link   href="https://discord.gg/NSQEweuWSb"              className="color-primary font-secondary fs-16 ms-lg-5 ms-md-5 ms-0"
            >
              <a href="https://discord.gg/NSQEweuWSb">
              <i class="bi bi-discord"></i>
            </a>{" "}
              Discord
            </Nav.Link>
            <Nav.Link href="https://instagram.com/code_tech_store?igshid=ZGUzMzM3NWJiOQ==" className="color-primary font-secondary fs-16 ms-lg-5 ms-md-5 ms-0">
              <a href="#">
                <i class="bi bi-instagram"></i>
              </a>{" "}
              code_tech_store
            </Nav.Link>
            <Nav.Link href="https://github.com/DarkBBR" className="color-primary font-secondary fs-16 ms-lg-5 ms-md-5 ms-0">
            <p>
              <a href="https://github.com/DarkBBR">
                <i class="bi bi-github"></i>
              </a>{" "}
              DarkBBR
            </p>
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}
